import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ItemsListRowItemArraySpanComponent } from '../array-span/array-span.component';

@Component({
    selector: 'fi-items-list-row-item-tags',
    templateUrl: './tags.component.html',
    styleUrls: ['./tags.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-items-list-row-item-tags' },
    standalone: false,
})
export class ItemsListRowItemTagsComponent extends ItemsListRowItemArraySpanComponent {
    tagClick($event: Event, tag) {
        $event.stopPropagation();
        $event.preventDefault();
        this.ngModel.SelectTag(tag);
    }
}
